import { MostlyFluidPage } from './components/structural/mostlyfluid-page'
import { ProductViewer } from './components/layout/product'
import { BoxMarginBottom30px, BoxMarginBottom20px } from './components/structural/box-margins'
import { TextStandard } from './components/typography/texts'
import { TextTitle } from './components/typography/titles'
// import { Filter } from './components/layout/filter'
import { ColorChoice } from './components/layout/color-choice'
import { createBoxVariantComponents } from './components/setup-factories'
import { Button } from './components/layout/button'
import { Gradient } from './components/layout/gradient'
import { BoxDesktopContent } from './components/structural/desktop-content'
import { useLocale } from './locales'
import { useCallback, useMemo, useState } from 'react'

const { BoxScrollWrapper } = createBoxVariantComponents({
  ScrollWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
})

export const App = () => {
  const { locales } = useLocale()

  const colorOptions = useMemo(() => window.colorConfiguratorColorOptions, [])
  const [selectedColorOption, setSelectedColorOption] = useState<
    Window['colorConfiguratorColorOptions'][number] | undefined
  >(undefined)

  const setColorOption = useCallback((colorTitle: Window['colorConfiguratorColorOptions'][number]) => {
    setSelectedColorOption(colorTitle)
  }, [])

  const selectColorOption = useCallback(() => {
    window.colorConfiguratorSelectColorTitle(selectedColorOption?.title ?? '')
  }, [selectedColorOption])

  return (
    <MostlyFluidPage>
      <BoxDesktopContent>
        <ProductViewer selectedColorOption={selectedColorOption} />
        <BoxMarginBottom30px>
          <TextStandard>{locales.common.obsText}</TextStandard>
        </BoxMarginBottom30px>
      </BoxDesktopContent>
      <BoxScrollWrapper>
        <div>
          <BoxMarginBottom20px>
            <TextTitle>{locales.common.vælgDinFarve}</TextTitle>
          </BoxMarginBottom20px>
          {/* <BoxMarginBottom30px>
              <Filter />
            </BoxMarginBottom30px> */}
        </div>

        <ColorChoice
          colorOptions={colorOptions}
          selectedColorOption={selectedColorOption}
          setColorOption={setColorOption}
        />

        <Gradient />
        {selectedColorOption !== undefined && (
          <Button type="button" onClick={selectColorOption}>
            {locales.common.vælgFarve}
          </Button>
        )}
      </BoxScrollWrapper>
    </MostlyFluidPage>
  )
}
